
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRainColour as ObiHeavyRainColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain-colour.js';
 
 
 

 
 export const ObiHeavyRainColour = createComponent({
   react: React,
   tagName: 'obi-heavy-rain-colour',
   elementClass: ObiHeavyRainColourElement,
   events: {
     
   }
  });
 
 